import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient';

export interface CategoryTip {
  title: string;
  content: string; // HTML content
}

const fetchCategoryTips = async (categoryCode: string): Promise<CategoryTip[]> => {
  const { data, error } = await supabaseClient
    .from('question_categories')
    .select('tips')
    .eq('category_code', categoryCode)
    .limit(1);

  if (error) {
    console.error('Error fetching category tips:', error);
    return [];
  }

  // Get tips from the first matching row
  const firstRow = data?.[0];
  return (firstRow?.tips as CategoryTip[]) || [];
};

export const useCategoryTips = (categoryCode: string | undefined) => {
  return useQuery({
    queryKey: ['category-tips', categoryCode],
    queryFn: () => fetchCategoryTips(categoryCode!),
    enabled: !!categoryCode,
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};

export default useCategoryTips;
